var _defs, _g, _path, _g2, _g3, _g4, _path2, _g5, _g6, _g7, _g8, _g9, _path3, _path4, _path5, _path6, _g10, _g11, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g12, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _path22, _g21, _g22, _g23, _g24, _path23, _g25, _path24, _path25, _path26, _path27, _g26, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalOn24Phase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 763.25 1316.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .local-webinar-disable-phase1{\n        fill: #edeef0 !important;\n      }\n      .local-webinar-disable-phase1:hover {\n        pointer-events: none;\n        fill: #edeef0 !important;  \n      }\n      \n      .local-webinar-disable-diamond-phase1{\n        fill: #a3ceff !important;\n      }\n      .local-webinar-disable-diamond-phase1:hover {\n        pointer-events: none;\n        fill: #a3ceff !important;  \n      }\n\n      .localp1-cls-1,.localp1-cls-4 {\n        stroke: #a3ceff;\n        stroke-width: 1px;\n      }\n\n      .localp1-cls-1, .localp1-cls-2, .localp1-cls-3 {\n        stroke-width: 1px;\n      }\n\n      .localp1-cls-1, .localp1-cls-4 {\n        fill: #a3ceff;\n        stroke-width: 1px;\n      }\n\n      .localp1-cls-5, .localp1-cls-6, .localp1-cls-2, .localp1-cls-7, .localp1-cls-8 {\n        stroke: #1071e5;\n        stroke-width: 0.5px;\n      }\n\n      .localp1-cls-5, .localp1-cls-9 {\n        fill: #fff;\n        stroke-width: 0.5px;\n      }\n\n      .localp1-cls-6, .localp1-cls-2 {\n        fill: #1071e5;\n      }\n\n      .localp1-cls-10, .localp1-cls-11, .localp1-cls-9, .localp1-cls-12, .localp1-cls-13, .localp1-cls-4 {\n        stroke-width: 0.5px;\n      }\n\n      .localp1-cls-10, .localp1-cls-7 {\n        fill: none;\n      }\n\n      .localp1-cls-11 {\n        fill: green;\n      }\n\n      .localp1-cls-12 {\n        fill: #3a414a;\n      }\n\n      .localp1-cls-13, .localp1-cls-3 {\n        fill: #a3ceff;\n      }\n\n      .localp1-cls-3 {\n        stroke: #a3ceff;\n      }\n\n      .localp1-cls-8 {\n        fill: url(#linear-gradient);\n      }\n      .yes{\n        fill: green !important;\n      }\n      \n      .no{\n        fill: red !important;\n      }\n      .nobg{\n        fill: transparent !important;\n        stroke-width: 0\n      }\n\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3672.49,
    y1: 949.42,
    x2: 3672.49,
    y2: 808.08,
    gradientTransform: "translate(-3499.5 1912.5) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#2954a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#1f3763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e182b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "rect-2",
    className: "localp1-cls-5",
    d: "M.5,190.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "K",
    className: "localp1-cls-12",
    d: "M28.59,216.97c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "localp1-cls-12",
    d: "M38.03,230.08c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "localp1-cls-12",
    d: "M53.72,216.63c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM53.17,228.45c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "localp1-cls-12",
    d: "M73.75,218.33c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "localp1-cls-12",
    d: "M81.42,214.12v-2.04h2.17v2.04h-2.17ZM81.42,229.81v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    className: "localp1-cls-12",
    d: "M89.16,226.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Q",
    className: "localp1-cls-12",
    d: "M108.24,212.76c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM108.24,228.18c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "localp1-cls-12",
    d: "M130.65,229.81l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "localp1-cls-12",
    d: "M142.19,212.76c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "localp1-cls-12",
    d: "M159.44,226v3.8h-2.04v-3.8h-7.94v-1.7l7.74-11.34h2.24v11.34h2.38v1.7h-2.38ZM157.4,215.41c-1.83,3.12-3.94,6.11-5.98,8.9h5.98v-8.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Q-2",
    "data-name": "Q",
    className: "localp1-cls-12",
    d: "M178.79,212.76c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM178.79,228.18c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "localp1-cls-12",
    d: "M196.24,216.63c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "localp1-cls-12",
    d: "M203.51,229.81v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-2",
    "data-name": "O",
    className: "localp1-cls-12",
    d: "M208.87,214.12v-2.04h2.17v2.04h-2.17ZM208.87,229.81v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-2",
    "data-name": "U",
    className: "localp1-cls-12",
    d: "M220.55,216.63c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "localp1-cls-12",
    d: "M232.98,216.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM236.51,222.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "localp1-cls-12",
    d: "M254.3,218.74c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-2",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M261.43,216.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM264.96,222.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "localp1-cls-12",
    d: "M278.06,227.7c-.75,1.49-1.97,2.38-4.07,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.01,1.15-6.72,4.75-6.79,2.17-.07,3.26.95,4.07,2.24,0-.75-.07-1.63.14-2.17h2.04l-.07,18.2h-2.17l.07-7.2ZM274.53,228.38c2.78,0,3.46-2.24,3.46-5.16s-.54-4.96-3.4-4.96-3.12,2.38-3.12,5.09.34,5.02,3.06,5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-2",
    "data-name": "L",
    className: "localp1-cls-12",
    d: "M287.5,230.08c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-3",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M302.17,216.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM305.7,222.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "localp1-cls-12",
    d: "M318.12,220.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-2",
    "data-name": "P",
    className: "localp1-cls-12",
    d: "M325.19,226.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "localp1-cls-12",
    d: "M154.48,243.25c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "localp1-cls-12",
    d: "M161.2,245.97c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM161.14,257.78c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-2",
    "data-name": "X",
    className: "localp1-cls-12",
    d: "M175.73,248.07c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-2",
    "data-name": "N",
    className: "localp1-cls-12",
    d: "M190.33,247.66c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-10",
    d: "M.5,190.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect-4",
    className: "localp1-cls-5",
    d: "M.96,570c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.97c-3.31,0-6-2.69-6-6v-100Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Q-3",
    "data-name": "Q",
    className: "localp1-cls-12",
    d: "M76.92,608.76c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM76.92,624.18c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-2",
    "data-name": "R",
    className: "localp1-cls-12",
    d: "M99.33,625.81l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-2",
    "data-name": "S",
    className: "localp1-cls-12",
    d: "M110.87,608.76c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-2",
    "data-name": "T",
    className: "localp1-cls-12",
    d: "M128.12,622v3.8h-2.04v-3.8h-7.94v-1.7l7.74-11.34h2.24v11.34h2.38v1.7h-2.38ZM126.08,611.41c-1.83,3.12-3.94,6.11-5.98,8.9h5.98v-8.9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "localp1-cls-12",
    d: "M145.77,612.63c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM145.23,624.45c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-2",
    "data-name": "V",
    className: "localp1-cls-12",
    d: "M153.17,625.81v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "localp1-cls-12",
    d: "M166.48,623.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM160.17,622.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-3",
    "data-name": "P",
    className: "localp1-cls-12",
    d: "M174.5,622.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-2",
    "data-name": "aa",
    className: "localp1-cls-12",
    d: "M184.14,609.92c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-2",
    "data-name": "ab",
    className: "localp1-cls-12",
    d: "M190.86,612.63c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM190.79,624.45c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-3",
    "data-name": "X",
    className: "localp1-cls-12",
    d: "M205.39,614.74c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-3",
    "data-name": "N",
    className: "localp1-cls-12",
    d: "M219.99,614.33c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "M-2",
    "data-name": "M",
    className: "localp1-cls-12",
    d: "M240.63,612.63c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM240.09,624.45c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-3",
    "data-name": "L",
    className: "localp1-cls-12",
    d: "M252.11,626.08c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-3",
    "data-name": "O",
    className: "localp1-cls-12",
    d: "M261.61,610.12v-2.04h2.17v2.04h-2.17ZM261.61,625.81v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-3",
    "data-name": "V",
    className: "localp1-cls-12",
    d: "M266.98,625.81v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-4",
    "data-name": "P",
    className: "localp1-cls-12",
    d: "M274.72,622.61c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rect-3",
    className: "localp1-cls-5",
    d: "M.96,382.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.97c-3.31,0-6-2.69-6-6v-100Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Q-4",
    "data-name": "Q",
    className: "localp1-cls-12",
    d: "M26.67,421.26c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM26.67,436.68c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "localp1-cls-12",
    d: "M50.58,426.15c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "localp1-cls-12",
    d: "M55.8,438.31v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Q-5",
    "data-name": "Q",
    className: "localp1-cls-12",
    d: "M86.36,421.26c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM86.36,436.68c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-2",
    "data-name": "ac",
    className: "localp1-cls-12",
    d: "M103.67,425.13c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM103.13,436.95c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-2",
    "data-name": "Z",
    className: "localp1-cls-12",
    d: "M118.61,428.6c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "localp1-cls-12",
    d: "M144.76,438.31l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-2",
    "data-name": "ad",
    className: "localp1-cls-12",
    d: "M158.34,435.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM152.02,434.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-3",
    "data-name": "U",
    className: "localp1-cls-12",
    d: "M170.29,425.13c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-3",
    "data-name": "ad",
    className: "localp1-cls-12",
    d: "M185.5,435.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM179.18,434.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "localp1-cls-12",
    d: "M201.52,425.4c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM195.88,436.81c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-4",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M209.87,425.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM213.4,430.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-4",
    "data-name": "X",
    className: "localp1-cls-12",
    d: "M224.4,427.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aa-3",
    "data-name": "aa",
    className: "localp1-cls-12",
    d: "M238.39,422.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-3",
    "data-name": "ab",
    className: "localp1-cls-12",
    d: "M245.11,425.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM245.05,436.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-4",
    "data-name": "V",
    className: "localp1-cls-12",
    d: "M253.53,438.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-5",
    "data-name": "V",
    className: "localp1-cls-12",
    d: "M258.9,438.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-4",
    "data-name": "ab",
    className: "localp1-cls-12",
    d: "M269.42,425.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM269.35,436.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "localp1-cls-12",
    d: "M290.2,438.31h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "L-4",
    "data-name": "L",
    className: "localp1-cls-12",
    d: "M306.29,438.58c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-3",
    "data-name": "ac",
    className: "localp1-cls-12",
    d: "M321.98,425.13c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM321.43,436.95c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-7",
    d: "M171.63,297.5v38.77c0,.13.1.23.23.23.12,0,.22.11.22.23v22.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-2",
    d: "M172.13,297.5h-1v-.5h1v.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-6",
    d: "M172.1,374.38l-4.65-14.26h9.27l-4.62,14.26Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "rect-5",
    className: "localp1-cls-5",
    d: "M1.88,757.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H7.88c-3.31,0-6-2.69-6-6v-100Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "localp1-cls-12",
    d: "M91.42,796.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM93.66,804.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-6",
    "data-name": "V",
    className: "localp1-cls-12",
    d: "M107.31,813.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-4",
    "data-name": "ad",
    className: "localp1-cls-12",
    d: "M120.62,810.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM114.3,809.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-5",
    "data-name": "P",
    className: "localp1-cls-12",
    d: "M128.63,810.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-4",
    "data-name": "aa",
    className: "localp1-cls-12",
    d: "M138.27,797.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-5",
    "data-name": "ab",
    className: "localp1-cls-12",
    d: "M144.99,800.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM144.93,811.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-5",
    "data-name": "X",
    className: "localp1-cls-12",
    d: "M159.52,802.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-4",
    "data-name": "N",
    className: "localp1-cls-12",
    d: "M174.12,801.83c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X-6",
    "data-name": "X",
    className: "localp1-cls-12",
    d: "M194.7,802.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-5",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M201.83,800.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM205.36,805.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "localp1-cls-12",
    d: "M215.95,813.31h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-4",
    "data-name": "O",
    className: "localp1-cls-12",
    d: "M222.47,797.62v-2.04h2.17v2.04h-2.17ZM222.47,813.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-6",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M232.99,800.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM236.52,805.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-2",
    "data-name": "ai",
    className: "localp1-cls-12",
    d: "M253.77,813.31h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-7",
    d: "M173,864.5v82.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-2",
    d: "M173.5,864.5h-1v-.5h1v.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-6",
    d: "M173,962.15l-4.63-14.26h9.27l-4.64,14.26Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-1",
    d: "M174,1185h-2v-31.1h2v31.1ZM174,1124.57h-2v-19.84h2v19.84Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-4",
    d: "M173,1103.73l1-.04v1.06h-2v-1.07l1,.05Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-1",
    d: "M173,1103.7l1.03-.03v1.1h-2.05v-1.1l1.02.03ZM172.03,1104.73h1.95v-1l-.98.03-.97-.04v1.01Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-4",
    d: "M173,1200.26l-4.63-14.26h9.27l-4.64,14.26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-1",
    d: "M173,1203.5l-6-18.5h12l-6,18.5ZM169.74,1187l3.26,10.03,3.26-10.03h-6.52Z"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "localp1-cls-11 yes",
    d: "M161.87,1137.2v6.93h-3.53v-6.93l-5.98-9.91h3.67l4.07,7.13,4.07-7.13h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "localp1-cls-11 yes",
    d: "M179.45,1140.87c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM176.4,1136.18c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "localp1-cls-11 yes",
    d: "M189.77,1134.76c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-7",
    d: "M172.1,489.5v57.62"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-2",
    d: "M172.6,489.5h-1v-.5h1v.5Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-6",
    d: "M172.1,561.88l-4.65-14.26h9.27l-4.62,14.26Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-7",
    d: "M171.63,113.5v54.12"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-2",
    d: "M172.13,113.5h-1v-.5h1v.5Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-6",
    d: "M171.63,182.38l-4.64-14.26h9.26l-4.62,14.26Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "local-webinar-disable-phase1",
    d: "M420.5,982.5c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ae-2",
    "data-name": "ae",
    className: "localp1-cls-12",
    d: "M460.51,1011.21c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "localp1-cls-12",
    d: "M470.9,1011.89c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-5",
    "data-name": "ad",
    className: "localp1-cls-12",
    d: "M486.85,1020.92c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM480.54,1019.77c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-4",
    "data-name": "U",
    className: "localp1-cls-12",
    d: "M498.81,1010.2c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-2",
    "data-name": "ah",
    className: "localp1-cls-12",
    d: "M516.46,1010.47c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM510.82,1021.87c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-7",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M524.81,1010.2c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM528.34,1015.7c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-3",
    "data-name": "Z",
    className: "localp1-cls-12",
    d: "M540.77,1013.66c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "P-6",
    "data-name": "P",
    className: "localp1-cls-12",
    d: "M554.62,1020.18c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-6",
    "data-name": "ab",
    className: "localp1-cls-12",
    d: "M564.19,1010.2c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM564.13,1022.01c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "M-3",
    "data-name": "M",
    className: "localp1-cls-12",
    d: "M585.58,1010.2c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM585.04,1022.01c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-8",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M598.15,1010.2c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM601.68,1015.7c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z-4",
    "data-name": "Z",
    className: "localp1-cls-12",
    d: "M620.89,1013.66c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-5",
    "data-name": "L",
    className: "localp1-cls-12",
    d: "M629.65,1023.64c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-4",
    "data-name": "M",
    className: "localp1-cls-12",
    d: "M645.34,1010.2c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM644.79,1022.01c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-5",
    "data-name": "N",
    className: "localp1-cls-12",
    d: "M665.37,1011.89c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-5",
    "data-name": "O",
    className: "localp1-cls-12",
    d: "M673.04,1007.68v-2.04h2.17v2.04h-2.17ZM673.04,1023.37v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-7",
    "data-name": "P",
    className: "localp1-cls-12",
    d: "M680.78,1020.18c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-9",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M690.35,1010.2c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM693.89,1015.7c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "localp1-cls-12",
    d: "M702.92,1010.2c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM703.53,1011.82c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "P-8",
    "data-name": "P",
    className: "localp1-cls-12",
    d: "M721.52,1020.18c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-7",
    "data-name": "ab",
    className: "localp1-cls-12",
    d: "M731.1,1010.2c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM731.03,1022.01c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Q-6",
    "data-name": "Q",
    className: "localp1-cls-12",
    d: "M500.44,1035.66c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM500.44,1051.07c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-3",
    "data-name": "ae",
    className: "localp1-cls-12",
    d: "M524.34,1040.55c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af-2",
    "data-name": "af",
    className: "localp1-cls-12",
    d: "M529.56,1052.7v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ab-8",
    "data-name": "ab",
    className: "localp1-cls-12",
    d: "M557.4,1039.53c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM557.34,1051.34c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-4",
    "data-name": "ac",
    className: "localp1-cls-12",
    d: "M572,1039.53c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM571.46,1051.34c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-5",
    "data-name": "Z",
    className: "localp1-cls-12",
    d: "M586.94,1042.99c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "N-6",
    "data-name": "N",
    className: "localp1-cls-12",
    d: "M611.05,1041.23c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-6",
    "data-name": "ad",
    className: "localp1-cls-12",
    d: "M626.66,1050.26c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM620.35,1049.1c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-5",
    "data-name": "U",
    className: "localp1-cls-12",
    d: "M638.61,1039.53c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-7",
    "data-name": "ad",
    className: "localp1-cls-12",
    d: "M653.82,1050.26c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM647.51,1049.1c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-3",
    "data-name": "ah",
    className: "localp1-cls-12",
    d: "M669.85,1039.8c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM664.21,1051.21c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-10",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M678.2,1039.53c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM681.73,1045.03c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-7",
    "data-name": "X",
    className: "localp1-cls-12",
    d: "M692.73,1041.63c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "rect-1",
    className: "localp1-cls-5",
    d: "M.5,6.5C.5,3.19,3.19.5,6.5.5h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6V6.5Z"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "localp1-cls-12",
    d: "M27.78,62.31v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-9",
    "data-name": "ab",
    className: "localp1-cls-12",
    d: "M46.11,49.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM46.04,60.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "localp1-cls-12",
    d: "M59.42,50.83c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-8",
    "data-name": "ad",
    className: "localp1-cls-12",
    d: "M74.7,59.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM68.38,58.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-7",
    "data-name": "V",
    className: "localp1-cls-12",
    d: "M80.33,62.31v-17.72h2.17v17.72h-2.17"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "W-11",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M97.65,49.13c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM101.18,54.63c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-2",
    "data-name": "aj",
    className: "localp1-cls-12",
    d: "M106.48,45.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM108.72,53.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-3",
    "data-name": "S",
    className: "localp1-cls-12",
    d: "M127.59,45.26c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-3",
    "data-name": "aj",
    className: "localp1-cls-12",
    d: "M136.35,45.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM138.59,53.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Q-7",
    "data-name": "Q",
    className: "localp1-cls-12",
    d: "M166.43,45.26c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM166.43,60.68c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-3",
    "data-name": "R",
    className: "localp1-cls-12",
    d: "M188.84,62.31l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-4",
    "data-name": "S",
    className: "localp1-cls-12",
    d: "M200.38,45.26c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-3",
    "data-name": "T",
    className: "localp1-cls-12",
    d: "M217.63,58.5v3.8h-2.04v-3.8h-7.94v-1.7l7.74-11.34h2.24v11.34h2.38v1.7h-2.38ZM215.59,47.91c-1.83,3.12-3.94,6.11-5.98,8.9h5.98v-8.9"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj-4",
    "data-name": "aj",
    className: "localp1-cls-12",
    d: "M229.51,45.47c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM231.75,53.95c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-8",
    "data-name": "V",
    className: "localp1-cls-12",
    d: "M245.4,62.31v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-9",
    "data-name": "ad",
    className: "localp1-cls-12",
    d: "M258.71,59.86c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM252.4,58.71c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-9",
    "data-name": "P",
    className: "localp1-cls-12",
    d: "M266.72,59.11c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa-5",
    "data-name": "aa",
    className: "localp1-cls-12",
    d: "M276.36,46.42c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-10",
    "data-name": "ab",
    className: "localp1-cls-12",
    d: "M283.09,49.13c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM283.02,60.95c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-8",
    "data-name": "X",
    className: "localp1-cls-12",
    d: "M297.62,51.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-7",
    "data-name": "N",
    className: "localp1-cls-12",
    d: "M312.22,50.83c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-8 local-webinar-disable-diamond-phase1",
    d: "M167.46,965.37c3.55-1.47,7.55-1.47,11.1,0l160.02,66.1c1.26.53,1.85,1.99,1.32,3.25-.25.6-.73,1.07-1.32,1.32l-160.03,66.1c-3.55,1.47-7.55,1.47-11.1,0L7.42,1036.04c-1.26-.53-1.86-1.98-1.34-3.24.25-.61.73-1.09,1.34-1.34l160.04-66.09Z"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "localp1-cls-9",
    d: "M92.89,1007.92c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM95.13,1016.41c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "localp1-cls-9",
    d: "M108.78,1024.76v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "localp1-cls-9",
    d: "M122.09,1022.32c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM115.78,1021.16c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "localp1-cls-9",
    d: "M130.1,1021.57c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "localp1-cls-9",
    d: "M139.75,1008.87c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "localp1-cls-9",
    d: "M146.47,1011.59c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM146.4,1023.4c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "localp1-cls-9",
    d: "M161,1013.69c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "localp1-cls-9",
    d: "M175.6,1013.29c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "az-2",
    "data-name": "az",
    className: "localp1-cls-9",
    d: "M202.69,1013.29c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "localp1-cls-9",
    d: "M215.52,1011.59c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM219.05,1017.09c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-2",
    "data-name": "aA",
    className: "localp1-cls-9",
    d: "M229.1,1011.59c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM232.63,1017.09c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "localp1-cls-9",
    d: "M239.9,1021.57c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "localp1-cls-9",
    d: "M251.85,1015.05c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA-3",
    "data-name": "aA",
    className: "localp1-cls-9",
    d: "M104.34,1040.92c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM107.87,1046.42c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "localp1-cls-9",
    d: "M120.7,1054.09l-3.46-5.3-3.53,5.3h-2.31l4.62-6.65-4.41-6.25h2.38l3.26,5.02,3.19-5.02h2.38l-4.35,6.25,4.62,6.65h-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "localp1-cls-9",
    d: "M131.16,1040.92c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM130.61,1052.74c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA-4",
    "data-name": "aA",
    className: "localp1-cls-9",
    d: "M143.72,1040.92c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM147.25,1046.42c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "localp1-cls-9",
    d: "M157.03,1042.62c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-3",
    "data-name": "av",
    className: "localp1-cls-9",
    d: "M166.74,1050.9c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "localp1-cls-9",
    d: "M179.09,1051.65c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM172.78,1050.49c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-4",
    "data-name": "av",
    className: "localp1-cls-9",
    d: "M187.11,1050.9c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "localp1-cls-9",
    d: "M191.52,1038.41v-2.04h2.17v2.04h-2.17ZM191.52,1054.09v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "localp1-cls-9",
    d: "M202.04,1040.92c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM201.98,1052.74c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "localp1-cls-9",
    d: "M216.78,1040.92c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-2",
    "data-name": "aB",
    className: "localp1-cls-9",
    d: "M231.58,1044.38c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "localp1-cls-9",
    d: "M241.63,1037.05c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM239.87,1054.09v-2.38h2.31v2.38h-2.31"
  })))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-3",
    d: "M363.16,1034.38l-23.36.36-.03-2,23.4-.37v2.01ZM401.52,1033.78l-5.9.1v-2l5.87-.1.03,2Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-3",
    d: "M339.83,1034.73l-4.03.07-.03-2,4.03-.07.03,2Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-13",
    d: "M416.76,1032.55l-14.2,4.85-.13-9.26,14.33,4.41Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-3",
    d: "M420,1032.5l-18.4,6.3-.2-12.03,18.6,5.73ZM403.55,1036l9.98-3.4-10.08-3.1.1,6.5Z"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "localp1-cls-11 no",
    d: "M375.05,1038.01l-7.33-12.97c.41,3.94.14,8.69.2,12.97h-3.12v-16.84h4.01l7.47,13.1c-.41-3.94-.14-8.76-.2-13.1h3.12v16.84h-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "localp1-cls-11 no",
    d: "M388.22,1024.84c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72ZM388.16,1035.98c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-7",
    d: "M591.63,975.5v-355.5h-231.53"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-2",
    d: "M592.13,976h-1v-.5h1v.5Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-6",
    d: "M345.33,620l14.26-4.64v9.28l-14.26-4.64Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-7",
    d: "M172.1,677l.7,57.62"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-2",
    d: "M172.6,677l-1,.02v-.52h1v.5Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "localp1-cls-6",
    d: "M172.98,749.38l-4.8-14.2,9.26-.12-4.46,14.32Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "rect-6",
    className: "localp1-cls-5 nobg",
    d: "M1.88,1210c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H7.88c-3.31,0-6-2.69-6-6v-100Z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "K-2",
    "data-name": "K",
    className: "localp1-cls-12",
    d: "M116,1252.97c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-12",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M126.52,1252.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM130.06,1258.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-13",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M140.1,1252.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM143.64,1258.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj-5",
    "data-name": "aj",
    className: "localp1-cls-12",
    d: "M155.72,1248.97c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM157.96,1257.45c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "localp1-cls-12",
    d: "M177.18,1254.33c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-10",
    "data-name": "ad",
    className: "localp1-cls-12",
    d: "M193.14,1263.36c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM186.82,1262.21c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-6",
    "data-name": "Z",
    className: "localp1-cls-12",
    d: "M206.31,1256.1c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-14",
    "data-name": "W",
    className: "localp1-cls-12",
    d: "M216.15,1252.63c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM219.68,1258.13c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "S-5",
    "data-name": "S",
    className: "localp1-cls-12",
    d: "M236.59,1248.76c5.57-.48,6.31,5.91,2.92,8.96l-4.21,3.73c-.75.75-1.56,1.49-1.97,2.51h8.76v1.83h-11.14c.14-6.72,8.69-6.38,8.69-12.36,0-1.9-1.09-2.92-3.06-2.92s-3.12,1.02-3.33,2.78l-2.17-.2c.41-2.78,2.31-4.07,5.5-4.35"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalOn24Phase1);
export default __webpack_public_path__ + "static/media/LOCAL-ON24-PHASE-1.f7701430d0d7c40e888a56b8385490f3.svg";
export { ForwardRef as ReactComponent };